<template>
  <div
    :class="[
      type === 'interpolate' ? 'inRecruit' : 'jobListBlock',
      $IsMobile ? 'mobile' : '',
    ]"
  >
    <ul class="jobListMore">
      <div v-for="(job, index) in jobPositionList" :key="index">
        <li @click="handleDetail(job)">
          <div class="top">
            <div class="jobInfo">
              <h5 class="tit">
                <span class="position" :title="job.positionName">{{
                  job.positionName
                }}</span>
                <span class="datePay" v-text="rangeFormatter(job)"></span>
              </h5>
              <div class="textInfo">
                <span v-if="cityFormatter(job)" v-text="cityFormatter(job)"
                  >地区</span
                >
                <span
                  v-text="
                    dictFormatter(educationOptions, job.educationalRequirements)
                  "
                  >学历</span
                >
                <span v-text="job.exp ? job.exp : '经验不限'">经验</span>
                <span v-text="job.count == '0' ? '人数不限' : job.count + '人'"
                  >人数</span
                >
              </div>
            </div>
          </div>
          <div class="bot">
            <div>
              <span class="title">职位关键词</span>
              <div class="label">
                <span
                  v-for="key in job.keywordList"
                  :key="key.id"
                  style="margin-bottom: 0;"
                  >{{ key.labelName }}</span
                >
              </div>
            </div>
            <div class="dateTime">
              <span v-if="job.updateTime"
                >{{ dateFormatter(job.updateTime) }} 发布</span
              >
              <el-divider direction="vertical"></el-divider>
              <span v-if="job.deadline"
                >{{ dateFormatter(job.deadline) }} 截止</span
              >
            </div>
          </div>
          <div v-if="job.willNature === INTERNSHIP">
            <div class="internship"><span>实习</span></div>
          </div>
          <div v-if="deadlineCheck(job) && type === 'allPosition'">
            <div class="online"><span>招聘中</span></div>
          </div>
          <div v-if="!deadlineCheck(job) && type === 'allPosition'">
            <div class="finish"><span>已结束</span></div>
          </div>
        </li>
      </div>
    </ul>

    <div class="pagination" v-if="page.totalElements">
      <span class="paginationTotal">共 {{ page.totalElements }} 条</span>
      <el-pagination
        v-if="!$IsMobile"
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.pageNumber"
        :page-size="searchParams.pageSize"
        layout="prev, pager, next, jumper"
        :total="page.totalElements"
      >
      </el-pagination>
      <el-pagination
        v-else
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.pageNumber"
        :page-size="searchParams.pageSize"
        background
        layout="prev, pager, next"
        :pager-count="5"
        small
        :total="page.totalElements"
      >
      </el-pagination>
    </div>
    <p class="emptyInfo" v-else>暂无内容</p>
  </div>
</template>

<script>
import moment from "moment";

const INTERNSHIP = 0; // 实习

const YEAR_WAGES = 0; // 年薪
const MONTHLY_WAGES = 1; // 月薪
const DAILY_WAGES = 2; // 日薪
const HOURLY_WAGES = 3; // 时薪
const FACE_TO_FACE_WAGES = 4;     // 面议
export default {
  name: "CommonList",
  props: ["type", "jobPositionList", "searchParams", "page"],
  data() {
    return {
      INTERNSHIP: INTERNSHIP,
      educationOptions: [], // 学历要求
      regionDict: [],
    };
  },
  computed: {
    logoHandle() {
      return function(file) {
        let imagePath = encodeURI(file);
        return `/files?imagePath=${imagePath}`;
      };
    },
  },
  created() {
    this.loadDictData();
  },
  methods: {
    deadlineCheck(row) {
      return new Date(row.deadline) > new Date();
    },
    loadDictData() {
      this.$store
        .dispatch("global/getTreeListByDictType", "education_requirement")
        .then((data) => {
          this.educationOptions = data;
        });
      this.getRegionCode().then((res) => {
        this.regionDict = res;
      });
    },
    handleCurrentChange(val) {
      this.$emit("pageNumber", val);
    },
    /** 日期格式化*/
    dateFormatter(data) {
      return moment(data).format("YYYY-MM-DD HH:mm");
    },
    /** 行业格式化*/
    industryFormatter(row) {
      if (!(row.enterpriseExtInfo && row.enterpriseExtInfo.industry)) {
        return "";
      }
      let industry = JSON.parse(row.enterpriseExtInfo.industry);
      return industry.join("");
    },
    /** 薪资范围格式化*/
    rangeFormatter(row) {
      let msg = "";
      let min = row.minimumWage;
      let max = row.maximumWage;
      switch (row.payMethod) {
        case YEAR_WAGES:
          msg = min / 10000 + "-" + max / 10000 + "W•年";
          break;
        case MONTHLY_WAGES:
          msg = min / 1000 + "-" + max / 1000 + "K•月";
          break;
        case DAILY_WAGES:
          msg = min + "-" + max + "•日";
          break;
        case HOURLY_WAGES:
          msg = min + "-" + max + "•时";
          break;
        case FACE_TO_FACE_WAGES:
          msg = "面议";
          break;
      }
      return msg;
    },
    /** 打开职位详情*/
    handleDetail(job) {
      if (process.env.NODE_ENV == "development") {
        window.open(window.location.origin + "/frontend#/jobDetails/" + job.id);
      } else {
        window.open(window.location.origin + "/#/jobDetails/" + job.id);
      }
    },
    /** 地址格式化*/
    cityFormatter(row) {
      return this.formatterRegionCode(this.regionDict, row.enterpriseAddress);
    },
  },
};
</script>

<style scoped lang="scss">
.jobListBlock.mobile {
  .jobListMore li {
    padding: 16px 12px 15px 16px;
    margin-top: 16px;
    border-radius: 10px;
    .finish,
    .online {
      width: 40px;
      height: 40px;
      border-radius: 0 10px 0;
      &::before {
        border-width: 40px 0 0 40px;
      }
      span {
        font-size: 12px;
        transform: rotate(45deg) scale(0.9);
        top: 8px;
        right: -4px;
      }
    }
    .internship {
      border-radius: 10px 0 0;
      &::before {
        border-width: 0 0 35px 35px;
      }
      > span {
        transform: scale(0.9) rotate(-45deg) translate(50%, 50%);
        top: 25%;
        left: -25%;
      }
    }
    .bot {
      margin-top: -10px;
      .dateTime {
        text-align: left;
      }
    }
  }
  .pagination {
    margin-top: 12px;
    font-size: 12px;
    padding: 12px;
    align-items: center;
    ::v-deep .el-pagination {
      .btn-prev,
      .btn-next,
      .el-pager {
        display: inline-block;
      }
      .el-pager li.btn-quicknext,
      .el-pager li.btn-quickprev {
        display: none;
      }
    }
  }
}
.emptyInfo {
  height: 150px;
  line-height: 120px;
  text-align: center;
}
</style>
